import { Node, mergeAttributes } from '@tiptap/core';

// Callout / admonition block (info · note · tip · warning · danger) — a common
// documentation primitive (GitBook "hints"). Holds block content; renders as a
// coloured box. Defined here (shared) so it renders identically via generateHTML
// on the docs site and in the editor. No React/NodeView → SSR-safe.

export const CALLOUT_TYPES = ['info', 'note', 'tip', 'warning', 'danger'] as const;
export type CalloutType = (typeof CALLOUT_TYPES)[number];

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    callout: {
      setCallout: (attrs?: { type?: CalloutType }) => ReturnType;
      toggleCallout: (attrs?: { type?: CalloutType }) => ReturnType;
      unsetCallout: () => ReturnType;
    };
  }
}

export const Callout = Node.create({
  name: 'callout',
  group: 'block',
  content: 'block+',
  defining: true,

  addAttributes() {
    return {
      type: {
        default: 'info',
        parseHTML: (el: any) => el.getAttribute('data-callout') || 'info',
        renderHTML: (attrs: any) => ({ 'data-callout': attrs.type }),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-callout]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { class: `callout callout-${HTMLAttributes['data-callout'] || 'info'}` }), 0];
  },

  addCommands() {
    return {
      setCallout: (attrs) => ({ commands }) => commands.wrapIn(this.name, attrs),
      toggleCallout: (attrs) => ({ commands }) => commands.toggleWrap(this.name, attrs),
      unsetCallout: () => ({ commands }) => commands.lift(this.name),
    };
  },
});
